export enum CLASSIFICATION {
  EVENTS = 'event',
  PUBLICATION = 'publication',
  NEWS = 'news',
  INNOVATION = 'innovations',
  STARTUP = 'startup',
  INNER_PAGE = 'inner-page',
}
